import type { CalendarEvent, CalendarEventFilterQuery } from "../Models/Domain";
import type { CalendarEventApi, CalendarEventFilterQueryApi } from "../Models/Api";

import { getCalendarsEvents } from "@/Services/TherapyApi/Calendars";
import CalendarEventTransformer from "@/Modules/Transformers/Calendars/Event";

import useCalendarsStore from "../Store";

import { CALENDAR_CLIENT_UUID } from "./fetchCalendars";
import useUserStore from "@/Modules/User/Store";

const fetchCalendarsEventsActionHandler = async (
  query: CalendarEventFilterQuery = {}
): Promise<CalendarEvent[]> => {
  const calendarsStore = useCalendarsStore();
  const userStore = useUserStore();
  const queryApi: CalendarEventFilterQueryApi = {
    patient_uuid: query.patientUuid,
    to_date: query.toDate,
    from_date: query.fromDate,
    is_deleted: query.isDeleted,
  };

  const resp: CalendarEventApi[] = await getCalendarsEvents(queryApi);

  calendarsStore.events = resp.map((e) =>
    CalendarEventTransformer.toDomain({
      ...e,
      calendar_uuid: userStore.getUserIsTherapist ? e.calendar_uuid : CALENDAR_CLIENT_UUID,
    })
  );
  calendarsStore.query = query;
  calendarsStore.isLoadingMore = false;

  return calendarsStore.events;
};

export default fetchCalendarsEventsActionHandler;
